/**
 * Public feature flags hook (no authentication required).
 * Fetches global feature flag values from the public API endpoint.
 */
import { useCallback, useEffect, useState } from "react";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "";
const REST_API_BASE_URL = API_ENDPOINT.replace(/\/graphql$/, "");

type PublicFeatureFlags = Record<string, boolean>;

type UsePublicFeatureFlagsResult = {
  flags: PublicFeatureFlags;
  loading: boolean;
};

/**
 * 公開 Feature Flag を取得する hook（認証不要）
 * @return {UsePublicFeatureFlagsResult} フラグ値とローディング状態
 */
export function usePublicFeatureFlags(): UsePublicFeatureFlagsResult {
  const [flags, setFlags] = useState<PublicFeatureFlags>({});
  const [loading, setLoading] = useState(true);

  const fetchFlags = useCallback(async () => {
    try {
      const res = await fetch(`${REST_API_BASE_URL}/api/public/feature-flags`);
      if (res.ok) {
        const data = (await res.json()) as { flags: PublicFeatureFlags };
        setFlags(data.flags);
      }
    } catch {
      // フラグ取得失敗時はデフォルト（空 = 全て無効）のまま
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFlags();
  }, [fetchFlags]);

  return { flags, loading };
}
